module.exports = __webpack_public_path__ + "img/gemxx.934c1b91.png";